import { Box, Flex, Heading, Text, useBreakpoint } from "@highoutput/ui-components";
import { InView } from "react-intersection-observer";
import Calendly from "~/components/calendly";
import { LargeBreak, MediumBreak, SmallBreak } from "../v2/helpers";
import { Confetti2Desktop } from "./confetti/2";
import Orbit from "./orbit";
import Underline from "./v2/underline";
export const SemiMediumBreak = () => {
  const breakpoint = useBreakpoint();
  return <br style={{ display: breakpoint === "md" || breakpoint === "sm" ? "block" : "none" }} />;
};
export default function Hero() {
  return (
    <InView triggerOnce>
      {({ ref, inView }) => (
        <Box
          ref={ref}
          as="section"
          flexGrow={1}
          role="banner"
          sx={{
            opacity: 0,
            willChange: "opacity",
            transition: "opacity 350ms ease-out",
            ...(inView && {
              opacity: 1,
            }),
          }}
          overflow={"hidden"}
          px={{ xl: "106px", lg: "24px", base: "16px" }}
          position="relative"
          zIndex={1}
          pb={{ lg: "100px", base: "64px" }}
          bgColor="white"
        >
          <Flex
            gap={{
              lg: "64px",
              xl: "24px",
            }}
            minWidth={{
              lg: "unset",
            }}
            maxWidth={{
              base: "375px",
              lg: "1024px",
              xl: "calc(567px + 24px + 529px)",
            }}
            marginX="auto"
            paddingTop={{
              base: "40px",
              lg: "64px",
              xl: "135px",
            }}
            direction={{
              base: "column",
              lg: "row",
            }}
            paddingBottom="24px"
          >
            <Flex
              width={"full"}
              flexGrow={0}
              flexShrink={0}
              maxWidth={{
                lg: "491px",
                xl: "593px",
              }}
              align={"center"}
              direction={{ lg: "row", base: "column" }}
            >
              <Box position="relative">
                <Heading
                  as="h2"
                  fontSize={{ xl: "56px", lg: "44px", base: "44px" }}
                  lineHeight={{ xl: "64px", lg: "48px", base: "44px" }}
                  letterSpacing={{
                    base: "-0.02em",
                    lg: "-0.02em",
                    xl: "0",
                  }}
                  position="relative"
                  zIndex={9}
                  color="#0D3050"
                  fontWeight={400}
                  fontFamily={"Georgia"}
                >
                  Maximize Your <SmallBreak /> Remote Team&apos;s Potential with
                  <MediumBreak />
                  <SmallBreak />
                  <SemiMediumBreak />
                  <LargeBreak />
                  <Text as="span" w={"1016px"} position={"relative"} zIndex={1}>
                    <Underline
                      position="absolute"
                      bottom={{ base: "-7px", lg: "-20px", xl: "-20px" }}
                      zIndex={-1}
                      left={{
                        base: "0px",
                        lg: "0px",
                        xl: "-7px",
                      }}
                      width={{
                        base: "316px",
                        lg: "316px",
                        xl: "416px",
                      }}
                      height={{
                        base: "26px",
                        lg: "50px",
                        xl: "52.46px",
                      }}
                      display="flex"
                      stroke="#FCD77C"
                    />
                    Expert Coaching
                  </Text>
                </Heading>
                <Text
                  fontSize={{ xl: "24px", lg: "20px", base: "16px" }}
                  lineHeight={{ xl: "32px", lg: "32px", base: "24px" }}
                  w={"full"}
                  marginTop={{
                    base: "24px",
                    lg: "16px",
                    xl: "28px",
                  }}
                  maxWidth={{ xl: "527px" }}
                  pb={{ xl: "28px", lg: "24px", base: "24px" }}
                  color="rgba(13, 48, 80, 0.8)"
                  fontFamily={"'Inter', sans-serif"}
                >
                  Don’t have time to coach and manage your team? Let us help you cultivate employee
                  growth for higher output and a better workplace environment.
                </Text>

                <Calendly
                  size="lg"
                  width={{
                    base: "full",
                    lg: "auto",
                  }}
                  bgColor="#F9D209"
                  mx={{ base: "auto" }}
                  h={{ base: "56px", lg: "48px" }}
                  fontFamily="'Inter', sans-serif"
                >
                  Let&apos;s Talk
                </Calendly>
              </Box>

              <Box
                position="relative"
                width="316px"
                height="316px"
                marginX="auto"
                marginTop="58px"
                display={{
                  base: "block",
                  lg: "none",
                }}
              >
                <Orbit />
              </Box>
            </Flex>

            <Box
              flexGrow={1}
              display={{
                base: "none",
                lg: "block",
              }}
            >
              <Flex
                position="relative"
                justifyContent={{
                  lg: "center",
                  xl: "flex-end",
                }}
              >
                <Orbit />
              </Flex>
            </Box>
          </Flex>
        </Box>
      )}
    </InView>
  );
}

// Sorry 'bout this. 😏🤐
export function FloatingConfettiHack() {
  return (
    <Box
      marginTop={{
        base: "11px",
        xl: "20px",
      }}
      position="relative"
    >
      <Confetti2Desktop
        stroke="secondary.default"
        width={{
          base: "213px",
          lg: "270px",
          xl: "390px",
        }}
        height={{
          base: "50px",
          lg: "72px",
          xl: "103.24px",
        }}
      />
    </Box>
  );
}
